import React, { useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { auth } from "./firebase";
import { Alert } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EmailInput from "./common/component/EmailInput";
import { setDataInLocalStorage } from "./common/util";
import { useNavigate } from "react-router";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [processing, setProcessing] = useState(false);

  const login = (e) => {
    e.preventDefault();
    setProcessing(true);

    auth
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;

        if (user.email.startsWith("kds.")) {
          handleSharedDeviceLogin("kds", user.uid);
        } else if (user.email.startsWith("pos.")) {
          handleSharedDeviceLogin("pos", user.uid);
        } else if (
          (user.uid === "IlMKaJ5NKCXcLu36UZGz2A1u0522" ||
            user.uid === "I8aQcGYi8kUtAy3nsju6mwQgwU23" ||
            user.uid === "DAmdo34Rkte0xNFnxEJ2VrZB59E3" ||
            user.uid === "Qk4Yzs59o0RELhGU70Bsp6aLZc03" ||
            user.uid === "MdAi63xSn4hY69FIL0X7wiT5q4a2" ||
            user.uid === "otIs8PNvpqS3YlD0URIExiINT1v2" ||
            user.uid === "QhJNP9WjhWb9FhRzUpeQThotnqf1" ||
            user.uid === "lUsNZAMboOgW05CB9gD8bUa3zld2" ||
            user.uid === "2lwEwl3W6sUDBUpyIT60nqdpjuG3" ||
            user.uid === "Qk4Yzs59o0RELhGU70Bsp6aLZc03" ||
            user.uid === "2llHpmuRrFXJCnYkh2GJ74wcyBJ2" ||
            user.uid === "otIs8PNvpqS3YlD0URIExiINT1v2" ||
            user.uid === "1ar0BkMly2XZIakr3XtOSi81dII2" ||
            user.uid === "aJtnQ9UZRVW6iwj4d3ETo7RL0U03" ||
            user.uid === "D7d6MSHHCXYBUMYSzEtlWJCMguY2") &&
          user.email.includes(".pos.")
        ) {
          handleSharedDeviceLogin("pos", user.uid);
        }
      })
      .catch((error) => {
        setProcessing(false);
        setMsg("Login failed");
      });
  };

  const handleSharedDeviceLogin = (mode, uid) => {
    // Check that screen size is at least that of a tablet
    if (window.innerWidth >= 768) {
      setDataInLocalStorage(mode, { uid });
      navigate(`/access-code`);
    } else {
      setMsg("Please use a tablet or larger device to log in.");
      auth.signOut();
    }
  };

  const reset = () => {
    if (email) {
      var actionCodeSettings = {
        url: `${window.location.origin}/login`,
        handleCodeInApp: false,
      };

      auth
        .sendPasswordResetEmail(email, actionCodeSettings)
        .then(() => {
          setEmail("");
          setPassword("");
          setMsg("Password reset email sent!");
        })
        .catch((error) => {
          setMsg("Invalid email");
        });
    } else {
      setMsg("Please enter your email");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box my={6}>
        <Box mb={3} align="center">
          <Typography variant="h2">Login</Typography>
          <Typography variant="subtitle1" color="textSecondary">
            to your bakestreet account
          </Typography>
        </Box>
        <Paper>
          <form onSubmit={login} autoComplete="on">
            <Box p={6}>
              {msg && (
                <Box mb={4}>
                  <Alert severity="error">{msg}</Alert>
                </Box>
              )}
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <EmailInput value={email} onChange={(val) => setEmail(val)} />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    value={password}
                    name="password"
                    variant="outlined"
                    fullWidth
                    id="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => setPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" color="primary" size="large" fullWidth>
                    LOG IN
                  </Button>
                  <Box mt={2} align="center">
                    <Link href="#" onClick={reset} underline="hover">
                      forgot password?
                    </Link>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Paper>
      </Box>
      <Typography variant="overline">{process.env.REACT_APP_VERSION}</Typography>
      <Backdrop open={processing} style={{ zIndex: "1000", color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}
export default Login;
